module.exports = __webpack_public_path__ + "img/telesticker-all.4f9ceab5.jpg";